/**
 * caseFlowMap.js — Mapeo de estados de caso a fases del flujo visual.
 *
 * Iter20 — Centraliza la jerarquía de fases Prevalidación → Diagnóstico → Documentos
 * para que CaseFlowStepper, CaseSummaryCard y otros componentes muestren coherencia.
 */

export const PHASES = [
  { key: "prevalidation", label: "Prevalidación", short: "Nivel 0" },
  { key: "diagnosis", label: "Diagnóstico", short: "Nivel 1" },
  { key: "documents", label: "Documentos", short: "Nivel 2" },
];

// Estado → fase activa (la que aparece resaltada)
export const STATE_TO_PHASE = {
  draft_intake: "prevalidation",
  nivel0_pending: "prevalidation",
  nivel0_ready: "prevalidation",
  out_of_scope: "prevalidation",

  nivel1_payment_pending: "diagnosis",
  nivel1_paid: "diagnosis",
  nivel1_processing: "diagnosis",
  nivel1_needs_human_review: "diagnosis",
  nivel1_revision_requested: "diagnosis",
  nivel1_delivered: "diagnosis",

  nivel2_offer_sent: "documents",
  nivel2_payment_pending: "documents",
  nivel2_paid: "documents",
  nivel2_processing: "documents",
  nivel2_needs_human_review: "documents",
  nivel2_revision_requested: "documents",
  nivel2_delivered: "documents",

  closed: "documents",
};

// Estado → estado de cada fase (todo | active | done | blocked)
export function phaseStatus(currentState, phaseKey) {
  const current = STATE_TO_PHASE[currentState] || "prevalidation";
  const order = PHASES.findIndex((p) => p.key === phaseKey);
  const currentOrder = PHASES.findIndex((p) => p.key === current);

  if (currentState === "out_of_scope" && phaseKey === "prevalidation") return "blocked";
  if (currentState === "closed") return order <= currentOrder ? "done" : "todo";
  if (order < currentOrder) return "done";
  if (order === currentOrder) return "active";
  return "todo";
}

// Próxima acción contextual del usuario para cada estado
export const NEXT_ACTION_BY_STATE = {
  draft_intake: { label: "Completar intake", path: (id) => `/cases/${id}/edit-draft`, variant: "primary" },
  nivel0_pending: { label: "Esperando prevalidación", path: null, variant: "info" },
  nivel0_ready: { label: "Ver resultado prevalidación", path: (id) => `/cases/${id}/prevalidation`, variant: "primary" },
  out_of_scope: { label: "Fuera de alcance — contactar soporte", path: null, variant: "warn" },

  nivel1_payment_pending: { label: "Pagar / Usar cuota Diagnóstico", path: (id) => `/cases/${id}/payment`, variant: "primary" },
  nivel1_paid: { label: "Pago confirmado — procesando", path: null, variant: "info" },
  nivel1_processing: { label: "Generando diagnóstico…", path: null, variant: "info" },
  nivel1_needs_human_review: { label: "En revisión humana", path: null, variant: "info" },
  nivel1_revision_requested: { label: "Revisión solicitada", path: null, variant: "info" },
  nivel1_delivered: { label: "Ver Diagnóstico / Solicitar Kit", path: (id) => `/cases/${id}`, variant: "primary" },

  nivel2_offer_sent: { label: "Configurar Kit Documental", path: (id) => `/cases/${id}/nivel2-request`, variant: "primary" },
  nivel2_payment_pending: { label: "Pagar / Usar cuota Kit", path: (id) => `/cases/${id}/payment-n2`, variant: "primary" },
  nivel2_paid: { label: "Pago confirmado", path: null, variant: "info" },
  nivel2_processing: { label: "Generando Kit Documental…", path: null, variant: "info" },
  nivel2_needs_human_review: { label: "En revisión humana", path: null, variant: "info" },
  nivel2_revision_requested: { label: "Revisión solicitada", path: null, variant: "info" },
  nivel2_delivered: { label: "Descargar Kit Documental", path: (id) => `/cases/${id}`, variant: "primary" },

  closed: { label: "Caso cerrado", path: (id) => `/cases/${id}`, variant: "muted" },
};
